import { render, staticRenderFns } from "./BoxFormDialog.vue?vue&type=template&id=6941cc0c&scoped=true"
import script from "./BoxFormDialog.vue?vue&type=script&lang=js"
export * from "./BoxFormDialog.vue?vue&type=script&lang=js"
import style0 from "./BoxFormDialog.vue?vue&type=style&index=0&id=6941cc0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6941cc0c",
  null
  
)

export default component.exports